import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { fetchJson, postJson } from '../lib/api';

export interface ImportJob {
  id: string;
  status: 'queued' | 'running' | 'completed' | 'failed';
  source: string;
  fileName?: string;
  filesProcessed?: number;
  contactsCreated?: number;
  organizationsCreated?: number;
  dealsCreated?: number;
  errors?: string[];
  startedAt?: string;
  completedAt?: string;
  createdAt: string;
}

export interface ImportJobsResponse {
  jobs: ImportJob[];
  total: number;
}

export function useImportJobs() {
  return useQuery({
    queryKey: ['import', 'jobs'],
    queryFn: () => fetchJson<ImportJobsResponse>('/api/import/jobs'),
  });
}

export function useStartImport() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: { source: string; filePath?: string; fileContent?: unknown }) =>
      postJson<ImportJob>('/api/import/start', data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['import', 'jobs'] });
    },
  });
}
